module.exports = __webpack_public_path__ + "img/android_icon.effce044.png";